module.exports = __webpack_public_path__ + "img/Slide10.cd1ac191.png";